import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { DEFAULT_RESUME_BUILDER_BASE_PATH } from '@glass/common/modules/pages/paths';
import filterJoin from '@glass/common/modules/strings/filterJoin';
import { currentOrigin } from '@glass/env/modules/origins/constants';
import useBuilderBasePath from '@glass/web/modules/resumes/router/resumeBuilderBasePath/useBuilderBasePath';

import ContentLink from '@glass/shared/components/Link/ContentLink';

const getUrlParts = (str) => {
  let urlParts;
  try {
    urlParts = new URL(str);
  } catch (e) {
    urlParts = null;
  }
  return urlParts;
};

const replaceResumeBuilderBasePath = (str, resumeBuilderBasePath) =>
  str?.replace(`/${DEFAULT_RESUME_BUILDER_BASE_PATH}`, `/${resumeBuilderBasePath}`);

function MarkdownLink(props) {
  const defaultBuilderBasePath = useBuilderBasePath();
  const { href, target, children } = props;
  const { origin, pathname, search, hash } = useMemo(() => getUrlParts(href) || {}, [href]);
  const internal = useMemo(() => {
    if (!href) {
      return false;
    }

    if (href?.[0] === '/') {
      return true;
    }
    if (__DEV__) {
      return origin === 'https://rocket-resume.com';
    }
    return origin && origin === currentOrigin;
  }, [origin, href]);

  const internalHref = useMemo(
    () =>
      replaceResumeBuilderBasePath(
        filterJoin([pathname, search, hash], '') || href,
        defaultBuilderBasePath,
      ),
    [pathname, search, hash, href, defaultBuilderBasePath],
  );

  return (
    <ContentLink href={internal ? internalHref : href} target={!internal ? '_blank' : target}>
      {children}
    </ContentLink>
  );
}

MarkdownLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  target: PropTypes.string,
};

export default MarkdownLink;
